import { Component, OnInit } from '@angular/core';
import { Station } from '../../models/station';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductionPlannerService } from "../productionplanner.service";
@Component({
  selector: 'app-station',
  templateUrl: './station.component.html',
  styleUrls: ['../../home/home.component.css']
})
export class StationComponent implements OnInit {
    isUpdateStation: boolean = false;
    specificStation: any = new Station();
    isStationList: boolean = true;
    AllStations: any[] = [];
    
    constructor(private _toastr: ToastrService, private productionPlannerService: ProductionPlannerService, private spinner: NgxSpinnerService){}

    ngOnInit(){
        this.getAllProductionPlannerStation();
    }

    getAllProductionPlannerStation(){
        this.spinner.show()
        this.productionPlannerService.getAllProductionPlannerStation().subscribe((data: any) => {
            this.AllStations = [];
            this.AllStations = data;
            if(this.AllStations.length > 0){
                this.isStationList = true;
            } else{
                this.isStationList = false;
            }
            this.spinner.hide();      
        }, (err) => { 
            this._toastr.error(err); 
            this.spinner.hide(); 
        });
    }

    onSubmit(f){
        f.submitted = true;
        if (f.form.valid) {
            let orderNumber = this.AllStations.length > 0 ? this.AllStations.find(s => (s.order === this.specificStation.Order && s.stationId != this.specificStation.StationId)) : false;
            if(orderNumber){
              this._toastr.warning("Duplicate order is not allow.");
            }
            else {
                this.specificStation.UserId = localStorage.getItem('userid');
            this.productionPlannerService.addUpdateProductioPlannerStation(this.specificStation).subscribe((response: any) => {
                if (response == true) {
                    if (this.isUpdateStation) {
                      this._toastr.success("Station has been updated successfully");
                      this.isUpdateStation = false;
                    }
                    else {
                      this._toastr.success("Station has been added successfully");                    
                    }
                    f.submitted = false;
                    this.specificStation = new Station();
                    this.getAllProductionPlannerStation();
                  }
                  else {
                    this._toastr.warning("Failed to Add/update station.");
                  }
            }, (err) => { 
                this._toastr.error(err);  
            });
            }
        }
    }

    editStation(item: any){
        this.specificStation.StationId = item.stationId;
        this.specificStation.StationName = item.stationName;
        this.specificStation.Order = item.order;
        this.specificStation.Status = item.status;
        this.isUpdateStation = true;
    }

    deleteStation(){}

}